import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { ensureDefaults } from './db/categories';
import { seedIfEmpty } from './dev/seed';
import { PwaBanner } from './ui/components/PwaBanner';
import { requestPersistOnce } from './lib/storage';
import { startSyncEngine } from './sync/engine';
import { maybeGenerateOnOpen } from './sync/review';

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let stopEngine: (() => void) | undefined;
    (async () => {
      await ensureDefaults();
      if (import.meta.env.DEV) await seedIfEmpty();
      setReady(true);
      // 破棄されにくいストレージを要求する（iOSでのオフライン利用に効く）
      void requestPersistOnce();
      stopEngine = startSyncEngine();
      // 週が終わっていて未作成なら、ふりかえりを1回だけ作る（設定でONのときのみ）
      void maybeGenerateOnOpen();
    })();
    return () => stopEngine?.();
  }, []);

  if (!ready) return <div className="boot">読み込み中…</div>;
  return (
    <>
      <RouterProvider router={router} />
      <PwaBanner />
    </>
  );
}
